import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { AdminProvider } from "./context/AdminContext";
import { Navbar } from "./components/Navbar";
import { CartSheet } from "./components/CartSheet";
import { Footer } from "./components/Footer";
import { HomePage } from "./pages/HomePage";
import { ShopPage } from "./pages/ShopPage";
import { ProductPage } from "./pages/ProductPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { CheckoutSuccessPage } from "./pages/CheckoutSuccessPage";
import { AdminLoginPage } from "./pages/AdminLoginPage";
import { AdminProductsPage } from "./pages/AdminProductsPage";
import { AdminProductFormPage } from "./pages/AdminProductFormPage";
import { BookPage } from "./pages/BookPage";

function App() {
  return (
    <AdminProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen flex flex-col bg-background text-foreground">
            <Routes>
              {/* Admin Routes (no navbar/footer) */}
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/products" element={<AdminProductsPage />} />
              <Route path="/admin/products/new" element={<AdminProductFormPage />} />
              <Route path="/admin/products/:productId/edit" element={<AdminProductFormPage />} />
              
              {/* Public Routes */}
              <Route path="*" element={
                <>
                  <Navbar />
                  <CartSheet />
                  <main className="flex-1">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/shop/:category" element={<ShopPage />} />
                      <Route path="/product/:productId" element={<ProductPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                      <Route path="/book" element={<BookPage />} />
                      <Route path="/cart" element={<CheckoutPage />} />
                    </Routes>
                  </main>
                  <Footer />
                </>
              } />
            </Routes>
          </div>
          <Toaster position="top-center" />
        </BrowserRouter>
      </CartProvider>
    </AdminProvider>
  );
}

export default App;
